var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"list-group no-border border-radius-2 mb-3"},[_c('div',{staticClass:"list-group-item list-group-item-primary"},[_c('strong',[_vm._v(_vm._s(_vm.$t('explore'))+" ")])]),_c('div',{staticClass:"list-group-item"},[_c('NodeDrilldownSearch',{attrs:{"view":"search"}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }